import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface StorageDurabilityState {
	persisted: boolean | null;
}

export interface StorageDurabilityRootState {
	storageDurability: StorageDurabilityState;
}

const initialState: StorageDurabilityState = { persisted: null };

export const storageDurabilitySlice = createSlice({
	initialState,
	name: "storageDurability",
	reducers: {
		setStoragePersisted: (state, action: PayloadAction<boolean>) => {
			state.persisted = action.payload;
		}
	}
});

export const { setStoragePersisted } = storageDurabilitySlice.actions;

export const selectStoragePersisted = (state: StorageDurabilityRootState): boolean | null =>
	state.storageDurability.persisted;

export default storageDurabilitySlice.reducer;
